import React, { useEffect, useRef } from 'react';
import HdModal from '../../../modal/components/modal/HdModal';
import QueryFailedRecordsContainer from '../QueryFailedRecordsContainer/QueryFailedRecordsContainer';
import { HdIconButton } from '../../../button/components/icon-button/HdIconButton';
import { HdIcon } from '../../../components';
import { getDataIdGenerator } from '../../../core/utils/generateDataId';
import {
  TRACKER_ACTIVATION_SYNC_HISTORY_FAILED_RECORDS_DIALOG_CLOSE,
  TRACKER_ACTIVATION_SYNC_HISTORY_FAILED_RECORDS_DIALOG_OPEN,
} from '../tracking';
import useAnalyticsTracker from '../../../analytics/hooks/useAnalyticsTracker';

function QueryFailedRecordsDialog({
  activation,
  query,
  failureType,
  failureScope,
  open,
  onClose
}) {
  const editorRef = useRef(null);
  const dataIdGenerator = getDataIdGenerator('activation-query-failed-records-dialog');
  const analyticsTracker = useAnalyticsTracker();

  useEffect(() => {
    open && analyticsTracker.eventTrack({
      action: TRACKER_ACTIVATION_SYNC_HISTORY_FAILED_RECORDS_DIALOG_OPEN,
      properties: {
        activationId: activation.id,
        query: query,
        failureType: failureType.value
      }
    });
  }, [open]);

  const handleClose = () =>{
    analyticsTracker.eventTrack({
      action: TRACKER_ACTIVATION_SYNC_HISTORY_FAILED_RECORDS_DIALOG_CLOSE,
      properties: {
        activationId: activation.id,
        query: query,
        failureType: failureType.value
      }
    });

    onClose(false);
  }

  return (
    <HdModal
      onClose={handleClose}
      placement='top'
      contentClassName='surface-on-surface'
      styling={{
        width: '1220px',
        marginTop: '50px',
        marginBottom: '50px'
      }}
      open={open}
      variant='custom'
      onTransitionEnd={() => {
        editorRef.current.refresh();
      }}
    >
      <div className='mt-6'>
        <div
          className='dialog-header w-100 border-bottom-0 py-0 px-6'
          tabIndex={0}>
          <div className='dialog-title flex-1'>
            Query {failureType.name}
          </div>
          <HdIconButton
            verticalEdge='both'
            horizontalEdge='both'
            className='ml-2'
            onClick={() => onClose()}
            dataId={dataIdGenerator('close')}
          >
            <HdIcon name='close' size={3} />
          </HdIconButton>
        </div>

        <div className='overflow-auto'>
          <div className='text-secondary my-3 px-6'>
            Use the SQL Editor to fetch the details of the {failureScope.toLowerCase()} records in the table.
          </div>

          <QueryFailedRecordsContainer
            warehouseId={activation.warehouse.id}
            currentQuery={query}
            syncFailureType={failureType}
            editorRef={editorRef}
          />
        </div>
      </div>
    </HdModal>
  );
}

export default QueryFailedRecordsDialog;
